import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import Spacer from '../components/Spacer';
import Card from '../components/Card';

function Services() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'LocalBusiness',
            name: 'CV Therapy',
            description: 'We offer a range of therapy services including individual, couples, and adolescent therapy.',
            url: 'https://cvtherapy.org/services',
            image: 'https://cvtherapy.org/assets/logo.svg',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '41865 Boardwalk Suite 208',
              addressLocality: 'Palm Desert',
              addressRegion: 'CA',
              postalCode: '92211',
              addressCountry: 'US',
            },
            telephone: '+1-760-459-5939',
            priceRange: '$$',
            hasOfferCatalog: {
              '@type': 'OfferCatalog',
              name: 'Therapy Services',
              itemListElement: [
                {
                  '@type': 'Offer',
                  itemOffered: {
                    '@type': 'Service',
                    name: 'Individual Therapy',
                    description: 'One-on-one therapy sessions for adults',
                  },
                  price: '150',
                  priceCurrency: 'USD',
                  availability: 'https://schema.org/InStock',
                },
                {
                  '@type': 'Offer',
                  itemOffered: {
                    '@type': 'Service',
                    name: 'Couples Therapy',
                    description: 'Therapy sessions for couples',
                  },
                  price: '175',
                  priceCurrency: 'USD',
                  availability: 'https://schema.org/InStock',
                },
                {
                  '@type': 'Offer',
                  itemOffered: {
                    '@type': 'Service',
                    name: 'Adolescent Therapy',
                    description: 'Therapy sessions for teenagers',
                  },
                  price: '150',
                  priceCurrency: 'USD',
                  availability: 'https://schema.org/InStock',
                },
              ],
            },
            openingHoursSpecification: [
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Monday',
                opens: '08:00',
                closes: '17:00',
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Tuesday',
                opens: '08:00',
                closes: '17:00',
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Wednesday',
                opens: '08:00',
                closes: '15:00',
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Thursday',
                opens: '08:00',
                closes: '17:00',
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Saturday',
                opens: '10:00',
                closes: '14:00',
              },
            ],
          })}
        </script>
      </Helmet>
      <Spacer />
      <div className="container" style={{ minHeight: 1000 }}>
        <h1 className="display-4 text-center text-primary">{t('services.title')}</h1>
        <h4 className="text-primary">{t('services.paragraph')}</h4>
        <p className="text-primary">{t('services.paragraph-2')}</p>
        <h4 className="text-primary">{t('services.tele-header')}</h4>
        <p className="text-primary">{t('services.tele-paragraph')}</p>
        <div className="row p-2">
          <div className="col-md-4 p-1">
            <Card
              classNames="h-100"
              header={t('services.service-header-individual')}
              subHeader={t('services.service-price-individual')}
              desc={t('services.service-paragraph-individual')}
              buttonDesc={t('services.schedule')}
            />
          </div>
          <div className="col-md-4 p-1">
            <Card
              classNames="h-100"
              header={t('services.service-header-couples')}
              subHeader={t('services.service-price-couples')}
              desc={t('services.service-paragraph-couples')}
              buttonDesc={t('services.schedule')}
            />
          </div>
          <div className="col-md-4 p-1">
            <Card
              classNames="h-100"
              header={t('services.service-header-adolescent')}
              subHeader={t('services.service-price-adolescent')}
              desc={t('services.service-paragraph-adolescent')}
              buttonDesc={t('services.schedule')}
            />
          </div>
        </div>
        <h4 className="text-primary">{t('services.reduced-header')}</h4>
        <p className="text-primary">{t('services.reduced-paragraph')}</p>
        <h4 className="text-primary">{t('services.insurances-header')}</h4>
        <p className="text-primary">{t('services.insurances-paragraph')}</p>
      </div>
    </>
  );
}

export default Services;
